/**
 * @generated SignedSource<<b865ffad653ffbd21817dcddee0c3103>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateContentChildInput = {
  clientMutationId?: string | null | undefined;
  contentKind: string;
  parentBranchId: string;
  title: string;
};
export type AddNodeButton_CreateContentChildNodeMutation$variables = {
  input: CreateContentChildInput;
};
export type AddNodeButton_CreateContentChildNodeMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly createContentChild: {
        readonly createdChildNode: {
          readonly id: string;
        };
        readonly tree: {
          readonly " $fragmentSpreads": FragmentRefs<"TreeEditorScreen_TreeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type AddNodeButton_CreateContentChildNodeMutation = {
  response: AddNodeButton_CreateContentChildNodeMutation$data;
  variables: AddNodeButton_CreateContentChildNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "TreeNode",
  "kind": "LinkedField",
  "name": "createdChildNode",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "CoordinatesV2",
  "kind": "LinkedField",
  "name": "coordinates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentRef",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TreeConfigConsequences",
              "kind": "LinkedField",
              "name": "configConsequences",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isRewardedTo",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AdvertisementConfiguration",
              "kind": "LinkedField",
              "name": "advertisementConfig",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isFeatured",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RootExtensionImpl",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RootStructureDefinition",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBeenPublishedOnce",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "typeDefinition",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "childRefs",
          "storageKey": null
        }
      ],
      "type": "BranchTypeDefinition",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "elements",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "elementType",
              "storageKey": null
            },
            {
              "kind": "TypeDiscriminator",
              "abstractKey": "__isElementV2"
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ELearningContentTypeDefinition",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "rewards",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "kind",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ContentTypeDefinition",
      "abstractKey": "__isContentTypeDefinition"
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Versioning",
  "kind": "LinkedField",
  "name": "versioning",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "draftVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "releaseVersion",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rootId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddNodeButton_CreateContentChildNodeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "CreateContentChildPayload",
                "kind": "LinkedField",
                "name": "createContentChild",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tree",
                    "kind": "LinkedField",
                    "name": "tree",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TreeEditorScreen_TreeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddNodeButton_CreateContentChildNodeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "CreateContentChildPayload",
                "kind": "LinkedField",
                "name": "createContentChild",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tree",
                    "kind": "LinkedField",
                    "name": "tree",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "rootNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v5/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c0994218fc80fb04dd06b71a8631555",
    "id": null,
    "metadata": {},
    "name": "AddNodeButton_CreateContentChildNodeMutation",
    "operationKind": "mutation",
    "text": "mutation AddNodeButton_CreateContentChildNodeMutation(\n  $input: CreateContentChildInput!\n) {\n  Admin {\n    Tree {\n      createContentChild(input: $input) {\n        createdChildNode {\n          id\n        }\n        tree {\n          ...TreeEditorScreen_TreeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteChildNodeButton_TreeNodeFragment on TreeNode {\n  id\n  hasBeenPublishedOnce\n  rootId\n}\n\nfragment ElementNode_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  id\n  title\n  elementType\n}\n\nfragment NodeConfigurationBadges_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    definitionType\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          displayType\n          configConsequences {\n            isRewardedTo\n          }\n          advertisementConfig {\n            isFeatured\n          }\n        }\n      }\n    }\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        kind\n        id\n      }\n    }\n  }\n  versioning {\n    draftVersion\n    releaseVersion\n  }\n}\n\nfragment Node_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on BranchTypeDefinition {\n      childRefs\n    }\n  }\n  ...NodeConfigurationBadges_TreeNodeFragment\n  ...ProjectExtendNodeConfigurationBadges_TreeNodeFragment\n}\n\nfragment ProjectExtendNodeConfigurationBadges_TreeNodeFragment on TreeNode {\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        kind\n        id\n      }\n    }\n  }\n}\n\nfragment TreeContainer_TreeFragment on Tree {\n  id\n  rootNode {\n    id\n    structureDefinition {\n      __typename\n      title\n    }\n    ...TreeContainer_TreeNodeFragment\n  }\n  nodes {\n    ...TreeContainer_TreeNodeFragment\n    id\n  }\n}\n\nfragment TreeContainer_TreeNodeFragment on TreeNode {\n  id\n  hasBeenPublishedOnce\n  parentId\n  structureDefinition {\n    __typename\n    coordinates {\n      parentRef\n    }\n    definitionType\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on BranchTypeDefinition {\n      childRefs\n    }\n    ... on ELearningContentTypeDefinition {\n      elements {\n        __typename\n        id\n        elementType\n        ...ElementNode_ElementV2Fragment\n      }\n    }\n  }\n  ...Node_TreeNodeFragment\n  ...DeleteChildNodeButton_TreeNodeFragment\n}\n\nfragment TreeEditorScreen_TreeFragment on Tree {\n  ...TreeContainer_TreeFragment\n}\n"
  }
};
})();

(node as any).hash = "67f94212d89cb025340a1b83f30c77cf";

export default node;
